module.exports = __webpack_public_path__ + "static/member-6-26fa18c86a2ceb663eb2aaac7c05269f.png";